import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import Perso from "../../assets/icons/Perso.svg";
import location from "../../assets/icons/location-border.svg";
import terrain from "../../assets/icons/terrain-icon.svg";
import cursor from "../../assets/icons/cursor-icon.svg";
import doc from "../../assets/icons/doc-icon.svg";
import click from "../../assets/icons/tab-click-icon.svg";
import palm from "../../assets/icons/palm-tree-2.svg";
import money from "../../assets/icons/money-icon.svg";
import palmGray from "../../assets/icons/palm-gray-icon.svg";

interface PalmProps {
  palms: any;
}

const CardDetailsPalm = ({ palms }: PalmProps) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="takaful--card-details-project-container">
      <div
        className="takaful--card-details-project-image"
        style={{
          backgroundImage: `url(${palms?.image_banner_ids})`,
        }}
      >
        <div className="takaful--card-details-project-name takaful--card-details-project-name-2">
          <img src={palm} alt="" />
          <span>وقف النخيل</span>
        </div>
      </div>

      <Row gutter={16} justify={"space-between"} dir="rtl">
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={17}
          xl={17}
          lg={17}
          md={17}
          sm={24}
          xs={24}
          className="takaful--card-details-project-titles"
          style={{ marginTop: "3vh" }}
        >
          <span className="takaful--card-details-project-text">
            ساهم معنا في صناعة أثر مستدام للأيتام، من خلال تبرعك لصندوق تكافل
            الوقفي.
          </span>

          <Row gutter={32}>
            <Col
              className="takaful--card-details-project-info-1"
              xxl={8}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <img src={Perso} alt="person" />
              <span>{palms?.participant_number} مساهم</span>
            </Col>
            <Col
              className="takaful--card-details-project-info-1"
              xxl={8}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <img src={location} alt="place" />
              <span>{palms?.address}، المدينة المنورة</span>
            </Col>
            <Col
              className="takaful--card-details-project-info-1"
              xxl={8}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <img src={terrain} alt="place" />
              <span>{palms?.farm_number} مزرعة</span>
            </Col>
          </Row>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={1} xs={1} />

        <Col
          className="takaful--card-details-project-qr"
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={15}
          xs={10}
        >
          <span style={{ lineHeight: "1.25rem" }}>
            رقم الترخيص: {palms?.license_number}
          </span>

          {palms?.license_attachment_ids?.length > 0 && (
            <img
              width={120}
              src={palms?.license_attachment_ids[0]}
              alt="qr-code"
            />
          )}
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      {/* Donation */}

      <div style={{ padding: "0 1.5rem" }}>
        <Row
          dir="rtl"
          gutter={4}
          justify={"center"}
          className="takaful--palm-details-container takaful--card-palm-details-container"
          style={{ marginTop: "2rem" }}
        >
          <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
            <Row align={"middle"} className="takaful--palm-details-row">
              <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={4}>
                <img alt="" src={palmGray} width={30} />
              </Col>
              <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9}>
                <span className="takaful--palm-details-title takaful--palm-details-title-2">
                  عدد النخيل
                </span>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9}>
                <p className="takaful--palm-details-value takaful--palm-details-value-2">
                  {palms?.palm_number}
                </p>
              </Col>
              <Col
                xxl={3}
                xl={3}
                lg={3}
                md={3}
                sm={2}
                xs={2}
                className="takaful--palm-details-unit takaful--palm-details-unit-2"
              >
                <h6>نخلة</h6>
              </Col>
            </Row>
          </Col>
          <Col
            xxl={1}
            xl={1}
            lg={1}
            md={1}
            sm={0}
            xs={0}
            className="takaful--palm-details-divider-container"
          >
            <div className="takaful--palm-details-divider-color"></div>
          </Col>
          <Col xxl={0} xl={0} lg={0} md={0} sm={24} xs={24}>
            <hr />
          </Col>
          <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
            <Row align={"middle"} className="takaful--palm-details-row-1">
              <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                <img alt="" src={money} width={35} />
              </Col>
              <Col xxl={10} xl={10} lg={10} md={10} sm={9} xs={9}>
                <span className="takaful--palm-details-title takaful--palm-details-title-green takaful--palm-details-title-2">
                  قيمة السهم
                </span>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9}>
                <p className="takaful--palm-details-value takaful--palm-details-value-2">
                  {palms?.share_amount}
                </p>
              </Col>
              <Col
                xxl={2}
                xl={2}
                lg={2}
                md={2}
                sm={2}
                xs={2}
                className="takaful--palm-details-unit takaful--palm-details-unit-2"
              >
                <h6 aria-hidden="true" className="icon-saudi_riyal"></h6>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      {/** Description */}
      <Row gutter={16} style={{ paddingTop: "2rem" }}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          className="takaful--card-details-project-description"
          xxl={22}
          xl={22}
          lg={22}
          md={22}
          sm={22}
          xs={22}
        >
          <span>شارك معنا لمن تحب وقف النخيل، ساهم في اسعادهم</span>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      {/** Statistics */}
      <Row
        gutter={16}
        justify={isMobile ? "center" : "space-between"}
        style={{ paddingTop: "2rem" }}
      >
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div
            className="takaful--card-details-project-statistics takaful--card-details-project-statistics-first 
              takaful--card-details-project-border-right"
          >
            <div className="takaful--card-details-project-statistics-title">
              <span>آخر تبرع</span>
              <img width={30} height={30} src={cursor} alt="card-details" />
            </div>
            <span>{palms?.last_payment_period}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-center">
            <div className="takaful--card-details-project-statistics-title">
              <span>عدد الزيارات</span>
              <img width={30} height={30} src={click} alt="card-details" />
            </div>
            <span>{palms?.visit_count}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-left">
            <div className="takaful--card-details-project-statistics-title">
              <span>عدد التبرعات</span>
              <img width={30} height={30} src={doc} alt="card-details" />
            </div>
            <span>{palms?.donation_number}</span>
          </div>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </div>
  );
};

export default CardDetailsPalm;
